module.exports = __webpack_public_path__ + "img/parkers.b11375ce.png";